// 直接导出模块
export default {

	// 名称
	name: 'char-number-input',

	// 表示时间
	events: {

		// 绑定事件
		bind(el) {

			// 事件动作
            el.handler = function () {

            	let expVal = '';
            	el.value.split('').forEach(item => {
            		if (/^\w+$/.test(item)) expVal += item;
            	});
                el.value = expVal;
            };
            el.addEventListener('input', el.handler);
		},
		unbind(el) {
			el.removeEventListener('input', el.handler);
		}
	}
}


// WEBPACK FOOTER //
// ./src/directive/OnlyCharNumber/index.js